// extracted by mini-css-extract-plugin
export default {"form":"SetNewPassword_form__v9aX+","title":"SetNewPassword_title__IG6od","subtitle":"SetNewPassword_subtitle__5l6t0"};